import { Container, Contents, ItemTitle, Title } from "../styles";

const TermsOfService = () => {
  return (
    <Container>
      <Title>서비스 이용약관</Title>

      <Contents>
        <ItemTitle>제 1조 (목적)</ItemTitle>
        <span>
          이 약관은 브이디컴퍼니㈜(이하 “회사”)가 제공하는 브이디김대표 및
          브이디김대표 관련 제반 서비스의 이용과 관련하여 회사와 회원과의 권리,
          의무 및 책임사항을 규정함을 목적으로 합니다.
        </span>

        <ItemTitle>제 2조 (정의)</ItemTitle>
        <span>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</span>
        <ol>
          <li>
            서비스”란 사업자 회원이 허용한 방법으로 취합한 회원의 매출, 사업장
            정보를 이용하여 회원에게 제공하는 수입 관리 서비스, POS 정산 조회,
            수입/지출 관리 서비스, 수익 분석 서비스, 브이디컴퍼니 계약 관리
            서비스, 신고대행 서비스, 기타 회원의 사업에 도움이 될 수 있는 정보
            제공 서비스 등의 업무를 수행할 수 있도록 브이디김대표
            애플리케이션(이하 앱, 사이트와 앱을 총칭하여 “사이트 등”)을 통하여
            회사가 제공하는 모든 서비스를 의미합니다.
          </li>
          <li>
            “회원”이라 함은 회사가 제시하는 이 약관에 따라 회사와 서비스 이용에
            관한 합의를 하고 회사가 제공하는 서비스를 이용하는 자를 말합니다.
          </li>
          <li>
            "사업자 회원"이라 함은 전항에 따라 회원의 자격을 득한 자 중 다음 각
            호의 요건을 충족하고, 이를 확인하기 위하여 회사가 요구하는 자료를
            제출한 자로서, 회사가 사업자 회원의 지위를 부여한 자를 말합니다.
          </li>

          <ol type="A">
            <li>적법하게 발부된 사업자 등록 번호를 보유한 사업자일 것</li>
            <li>
              본인이 보유하고 있는 사업자 등록번호와 연결된 사업장에 관하여
              최종적 의사결정을 할 수 있는 적법한 권한을 보유하고 있어야 하며
              (법인의 경우 대표이사 또는 지배인), 이를 검증하기 위하여 회사가
              요구하는 절차에 응할 것
            </li>
          </ol>

          <li>
            "조회 회원"이라 함은 사업자 회원의 동의를 얻어 사업자 회원이 등록한
            사업장 정보를 조회하는 서비스를 이용하는 자를 말합니다.
          </li>

          <li>
            "가맹점 회원"이라 함은 적법하게 브이디컴퍼니 서비스를 계약하여
            브이디컴퍼니 가맹점의 자격을 득한 자 중에서, 회사가 요구한
            브이디컴퍼니 자료를 제출하여 브이디김대표 앱에서 가맹점 회원의
            지위를 부여한 자를 말합니다.
          </li>

          <li>
            “유료서비스”라 함은 회사가 제공하는 서비스 중, 그 이용을 위하여
            별도의 과금을 하는 서비스를 말합니다.
          </li>

          <li>
            "사업장"이라 함은 사업자 회원이 사업을 영위하고 있는 장소이면서
            회사가 제공하는 서비스를 이용할 수 있도록 회사가 요구하는 자료를
            제출한 곳을 말합니다.
          </li>

          <li>
            "임직원 회원"이라 함은 사업자 회원에게 권한을 승계 받아
            브이디김대표에 가입하여 업무를 수행하거나 서비스를 이용하는 책임자를
            말합니다.
          </li>
          <li>
            “서비스 이용계약”이란 회사가 회원을 위해 제공하는 서비스를
            계속적으로 이용하기 위하여 회사와 회원 사이에 체결되는 계약을
            의미합니다.
          </li>
        </ol>

        <ItemTitle>제 3조 (약관의 명시와 개정)</ItemTitle>
        <ol>
          <li>
            회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 회원가입
            초기 화면에 게시합니다.
          </li>
          <li>
            회사는 약관의 규제에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에
            관한 법률(이하 “정보통신망법”) 등 관련법을 위배하지 않는 범위에서 이
            약관을 개정할 수 있습니다.
          </li>
          <li>
            회사는 서비스 운영상 필요에 따라 본 약관의 내용을 변경할 수 있으며
            다음 각 호의 기간 동안 변경된 약관, 변경 사유 및 시행일을 사전
            공지하고, 회원에게 별도의 전자적 수단(전자우편, 문자 메시지,
            카카오톡 메시지, 서비스 계정 내 알림 메시지 등)으로 개별 통지합니다.
          </li>

          <ol type="A">
            <li>
              회원의 권리·의무에 중대한 내용 변경일 경우, 그 내용 및 시행일을
              명시하여 시행일로부터 30일 전부터 시행일 후 상당기간 동안
            </li>
            <li>
              기타 회원에게 불리하거나 중요사항에 대한 변경이 아닌 경우 최소 7일
              전부터 시행일 후 상당기간 동안
            </li>
          </ol>

          <li>
            회사가 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에
            의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게
            공지 또는 고지하였음에도 회원이 명시적으로 거부의 의사표시를 하지
            아니한 경우, 회원이 개정약관에 동의한 것으로 봅니다.
          </li>
          <li>
            회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정 약관의
            내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수
            있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는
            경우에는 회사는 이용계약을 해지할 수 있습니다.
          </li>
          <li>
            본 약관에서 명시되지 아니한 사항이나 약관의 해석에 관한 사항은 관련
            법규 또는 상관례에 따릅니다.
          </li>
        </ol>

        <ItemTitle>제 4조 (서비스 이용계약 체결)</ItemTitle>
        <span>
          본 약관은 서비스를 이용하려고 하는 자가 본 약관에 동의한다는
          의사표시와 함께 이용신청을 하고, 회사가 이를 승낙함으로써 성립합니다.
        </span>

        <ItemTitle>제 5조 (회원 가입 신청의 승낙과 제한)</ItemTitle>
        <ol>
          <li>
            사업자 회원 가입을 희망하는 자에 대하여 다음 각 호의 사유가 없는
            경우 회사는 사업자 회원 가입을 승낙합니다. 다음 각 호의 사유에
            해당하는 경우 회사는 해당 사유가 해소될 때까지 회원 가입 승낙을
            유보하거나 승낙을 하였더라도 서비스 이용계약을 해지할 수 있습니다.
          </li>

          <ol type="A">
            <li>
              회원 필수 등록사항을 허위로 입력하거나 타인의 정보를 입력한 경우
            </li>
            <li>
              최근 1년간 동항에 의하여 회원 자격을 상실한 이력이 있는 경우
            </li>
            <li>가입신청자가 만 14세 미만인 경우</li>
            <li>
              기타, 회사가 판단하기에 가입신청자에 대하여 본 서비스를 이용하도록
              허용하는 것이 부적절하거나, 회사의 안정적 서비스 제공에 부정적
              영향이 있을 수 있다고 판단하는 경우
            </li>
          </ol>

          <li>
            가입신청자는 본 조 제1항의 요건을 확인하기 위하여 회사가 요청하는
            절차에 적극 협조하기로 합니다. 이용계약의 성립 시기는 회사가
            가입완료 사실을 신청절차 상에서 표시한 시점으로 합니다.
          </li>
          <li>
            회원 중에서, 사업자 회원이 특정하여 사업자 회원이 접근 가능한
            브이디김대표 서비스에 접근할 수 있도록 허용한 자를 조회 회원이라고
            하며, 회사는 사업자 회원의 지시에 따라 조회 회원에게 정보 열람을
            허용할 수 있습니다. 조회 회원은 사업자 회원 의사에 반하여 회사에
            대하여 사업자 회원의 정보 열람 허용을 요구할 수 없습니다.
          </li>
        </ol>

        <ItemTitle>제 6조 (베타 서비스의 제공)</ItemTitle>
        <ol>
          <li>
            회사는 신규 서비스를 상용화하기 전 회원을 대상으로 테스트 목적의
            베타 서비스를 일정한 기간 동안 제공할 수 있습니다. 베타 서비스를
            시작하는 경우 회사는 회원들에게 베타 서비스의 내용, 제공 기간 등을
            공지합니다.
          </li>
          <li>
            베타 서비스는 정식 서비스가 아니므로, 베타 서비스 제공 기간 동안
            서비스 내용의 변경, 추가, 수정될 수 있습니다. 회사는 베타 서비스를
            제공하는 도중 예상치 못한 손해나 문제가 발생하였을 경우에 회원에게
            사전 공지없이 베타 서비스를 종료할 수 있습니다.
          </li>
        </ol>

        <ItemTitle>제 7조 (서비스의 제한)</ItemTitle>
        <ol>
          <li>
            회원이 다음 각 호의 사유에 해당하는 경우 회사는 회원자격을 제한 또는
            정지하거나 서비스의 이용을 제한하는 등의 조치를 취할 수 있습니다.
          </li>

          <ol type="A">
            <li>
              회원 필수 등록사항을 허위로 입력하거나 타인의 정보를 입력한 경우
            </li>
            <li>
              본 약관에 따라 회사로부터 소정의 증빙자료 제출 요청을 받고도
              정당한 사유 없이 응하지 아니하거나 허위의 내용이 기재된 자료, 위조
              또는 변조된 자료를 제출하는 경우
            </li>
            <li>
              서비스를 회사가 허용한 이용 목적을 넘어, 회원의 영리목적으로
              이용하거나, 타인의 권리를 침해하는 등, 불법적 목적을 위하여
              이용하는 경우
            </li>
            <li>
              회사가 제공하는 경제적 혜택을 그 통상적 수령 요건에 반하여 부정한
              방법으로 취득하거나, 부정한 방법으로 취득하기 위한 시도를
              반복적으로 하는 경우
            </li>
            <li>
              권한 없는 자에게 자신의 계정을 대여하거나 권한 없이 다른 회원의
              계정으로 접속하여 서비스를 이용한 경우
            </li>
            <li>
              유료서비스의 사용 요금의 납부 수단으로 등록된 지급결제 수단에
              하자가 있거나, 납부가 지연되는 경우
            </li>
            <li>
              재화 등을 구매한 후 정당한 이유 없이 상습적으로 취소, 교환 및
              반품하여 회사의 업무를 방해하는 경우
            </li>
            <li>
              서비스를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는
              행위를 하는 경우
            </li>
            <li>
              고의적으로 회사의 명예나 신용을 실추시키거나, 근거 없이 회사
              서비스의 신뢰성을 훼손하는 행위를 하는 경우
            </li>
            <li>
              서비스의 이용과정에서 회사의 직원에게 폭언, 협박 또는 음란한 언행
              등으로 회사의 업무를 방해하는 경우
            </li>
            <li>
              서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나,
              사이트 등에 악성코드, 바이러스 등의 프로그램을 고의 또는 과실로
              설치, 유포하는 행위
            </li>
            <li>
              기타 사이트 등의 원활한 운영을 저해하거나 회사 업무에 장애를
              발생하는 경우
            </li>
          </ol>

          <li>
            제 1항에 따른 회사의 제재 조치로 인해 회원 등록이 말소된 회원에 관한
            정보는 본 서비스의 부정사용 방지 등의 목적을 위하여 1년간
            보관됩니다.
          </li>
        </ol>

        <ItemTitle>제 8조(회원정보의 관리)</ItemTitle>
        <ol>
          <li>
            회원은 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만,
            서비스 관리를 위해 필요한 계정은 수정이 불가능합니다.
          </li>
          <li>
            회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 전자우편 기타
            방법으로 회사에 대하여 그 변경사항을 알려야 합니다. 회원이 운영하는
            사업의 휴업, 폐지, 업종변경, 주소이전, 사업장의 추가 또는 제외 등,
            본 약관에 따른 서비스의 제공에 중요한 영향을 미치는 사항에 관한
            변동이 있는 경우, 회원은 지체없이 그 변동 내용을 본 항에 정한 방법에
            따라 회사에 알려야 합니다.
          </li>
          <li>
            제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는
            책임지지 않습니다. 만약, 제2항 후단의 중요한 사항에 관하여 변동
            사항이 회사에 고지되지 않음으로 인하여 회사에 손해가 발생하는 경우,
            회사는 회원에 대하여 그 손해의 배상을 청구할 수 있습니다.
          </li>
          <li>
            회원에 관한 정보가 변경되었을 경우 해당 회원은 기존에 회사로부터
            제공받던 서비스의 이용에 제한을 받을 수 있으며, 이 경우 회사는
            회사가 제공하는 서비스 앱, 웹 페이지, 이메일 등 적절한 방식을 통해
            해당 회원에게 통지를 합니다.
          </li>
        </ol>

        <ItemTitle>제 9조 (유료 서비스 이용)</ItemTitle>
        <ol>
          <li>
            사업자 회원은 사업자 회원의 선택에 따라, 회사가 제공하는
            유료서비스에 가입하고, 그 서비스 사용 요금을 결제한 후 유료서비스를
            이용할 수 있습니다.
          </li>
          <li>
            회사에 유료서비스 신청을 하고, 그 대금을 결제한 사업자 회원은 해당
            유료서비스를 전혀 사용하지 아니하였을 경우에 한하여 결제일로부터 7일
            이내에 회사에 결제 취소(청약 철회)를 요청할 수 있습니다.
          </li>
          <li>
            사업자 회원이 제1항의 청약 철회가 가능한 유료서비스에 대하여 청약
            철회 가능한 기간을 경과하여 청약 철회를 신청하거나, 전자상거래
            등에서의 소비자 보호에 관한 법률 등 기타 관계 법령에서 정한 청약
            철회 제한 사유에 해당하는 경우에는 청약 철회가 제한됩니다.
          </li>
          <li>
            청약 철회는 사업자 회원이 서면, 전화, 전자우편 등의 방법으로 할 수
            있으며, 회사에 의사를 표시하여 회사에 도달될 때 그 효력이 발생하고,
            회사는 사업자 회원의 의사표시를 접수한 후 지체 없이 그 처리결과를
            사업자 회원에게 회신합니다.
          </li>
        </ol>

        <ItemTitle>제 10조 (회원의 의무)</ItemTitle>
        <ol>
          <li>
            회원은 본 약관 및 관계 법령을 준수하여야 하며, 회사의 정상적인 업무
            수행을 방해하는 행위를 해서는 안됩니다.
          </li>
          <li>
            회원은 제 8조에 따라, 본인의 회원 정보를 관리하고 그 정보가 최신
            정보로 유지되도록 하여야 합니다.
          </li>
          <li>
            회원의 계정에 관한 관리책임은 회원에게 있으며, 이를 권한 없는
            제3자가 이용하도록 하여서는 안됩니다.
          </li>
          <li>
            회원은 계정이 도용되거나 제3자가 사용하고 있음을 인지한 경우에는
            이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다. 회원이 회사에
            그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아
            발생한 불이익에 대하여 회사는 책임지지 않습니다.
          </li>
          <li>
            회원은 본 약관에 따라 회사가 통지 또는 공지하는 사항을 확인하고
            준수할 의무가 있습니다.
          </li>
        </ol>

        <ItemTitle>제 11조 (회원의 의무 위반에 대한 제재조치)</ItemTitle>
        <ol>
          <li>
            회원이 제 10조 1항을 위반하였을 경우, 회사는 해당 회원에게 사전
            통지한 후 회원의 서비스 이용 중지, 회원 ID 삭제조치, 회원 강제 탈퇴
            및 재가입 제한 조치(이하 “제재조치”라 합니다)를 취할 수 있습니다.
            다만, 서비스 정상화 또는 민원처리 등 긴급한 사정이 있을 경우, 회사는
            제재조치를 취한 후 사후적으로 해당 회원에게 통지할 수 있습니다.
          </li>
          <li>
            회원은 제1항에 따른 회사의 제재조치에 대하여 이의 사유 및 증빙자료를
            제출하는 방식으로 회사에게 이의를 신청할 수 있습니다. 회원의 이의
            신청을 접수한 경우, 회사는 제출된 이의 사유 및 증빙자료 기타 관련
            사항을 신중히 검토하여 이의 신청에 대한 판단을 하고 그 결과를
            통지합니다.
          </li>
        </ol>

        <ItemTitle>제 12조 (손해배상)</ItemTitle>
        <ol>
          <li>
            회사의 귀책사유 또는 회사가 본 약관에 규정된 의무를 위반하여
            회원에게 손해가 발생한 경우, 회사는 그 손해를 배상합니다.
          </li>
          <li>
            회원의 귀책사유 또는 회원이 본 약관에 규정된 의무를 위반하여
            회사에게 손해가 발생한 경우, 회원은 그 손해를 배상합니다.
          </li>
        </ol>

        <ItemTitle>제 13조 (회사의 의무)</ItemTitle>
        <ol>
          <li>
            회사는 이 약관에서 정한 내용에 따라 서비스를 안정적, 계속적으로
            제공할 수 있도록 최선을 다하여 노력합니다.
          </li>
          <li>
            회사는 서비스 이용이나 운영과 관련된 회원의 불만사항을 접수하는
            경우, 회사는 이를 지체없이 처리하여 그 결과를 이메일, 전화 등의
            방법으로 통지합니다. 다만, 불만사항 내용 확인 및 경위 파악, 접수
            내용 처리 등에 상당한 시간이 소요될 경우, 회사는 그 사유와
            처리일정을 회원에게 미리 통지합니다.
          </li>
          <li>
            회사는 회사가 본 약관의 변경, 회사가 제공하는 서비스의 구체적
            내용이나 이용 방법 등에 변경, 서비스의 일시 중단 등 사유가 발생하는
            경우, 본 조에 정한 바에 따라 회원에게 통지합니다.
          </li>
          <li>
            회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보
            보호를 위한 보안 시스템을 갖추어 회원의 개인정보 보호에 최선을
            다하여야 합니다.
          </li>
        </ol>
        <span>
          회사는 정보통신망법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를
          보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및
          회사의 개인정보 처리방침이 적용됩니다.
        </span>

        <ItemTitle>제 14조(회사의 면책)</ItemTitle>
        <ol>
          <li>
            회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할
            수 없는 경우 서비스 제공에 관한 책임이 면제됩니다.
          </li>
          <li>
            회사는 회원의 고의 또는 과실로 인하여 발생한 서비스 이용의 장애 및
            이로 인하여 발생한 손해에 대하여 어떠한 책임도 부담하지 않습니다.
          </li>
        </ol>

        <ItemTitle>제 15조(회원에 대한 통지 및 공지)</ItemTitle>
        <ol>
          <li>
            회사는 회원이 회원 가입 신청 시 등록한 이메일, 휴대전화 문자메시지
            또는 앱 푸시 알림 중 회원이 수신에 동의한 수단을 활용하여 회원에
            대한 각종 공지나 통지를 이행할 수 있습니다.
          </li>
          <li>
            회사는 회원에게 이용약관, 개인정보 취급방침 등 일체의 약관, 서비스
            이용 관련 일정한 사항이나 정보를 알리거나 안내할 목적으로 사이트
            등의 게시판이나 서비스 화면에 그 내용을 게시하거나 제1항에 기재된
            수단을 활용하여 공지할 수 있습니다.
          </li>
          <li>
            회원에게 공통적으로 적용되는 내용을 통지할 경우, 회사는 1주일 이상
            사이트 등의 게시판이나 화면에 일정한 사항을 게시하여 공지함으로써 각
            회원에 대한 개별 통지를 갈음할 수 있습니다. 다만, 회원의 권리·의무에
            중대한 영향을 미치는 사항에 대해서는 게시기간을 연장하여 공지합니다.
          </li>
        </ol>

        <ItemTitle>제 16조 (회원의 탈퇴)</ItemTitle>
        <ol>
          <li>
            회원은 언제든지 서비스 화면의 고객센터를 통하여 이용계약 해지
            신청(회원탈퇴)을 할 수 있습니다. 회원이 이용계약 해지를 신청한 경우
            회사는 본인 여부를 확인할 수 있으며, 관계법규 등이 정하는 바에 따라
            이를 즉시 처리합니다. 단, 회사는 서비스 운영 원칙에 따라 30일 동안
            재가입을 제한할 수 있습니다. 탈퇴 회원에 관한 정보는 본 서비스의
            부정사용 방지 등의 목적을 위하여 30일간 보관됩니다. 회원이
            유료서비스 잔액을 보유하고 있는 경우, 회원은 탈퇴 신청 전에 이를
            소진하거나 고객센터 등을 통하여 환불 신청을 하여야 합니다. 탈퇴 신청
            시 회사가 유료서비스 잔액을 안내하였음에도 불구하고, 이를 소진하거나
            환불 신청하지 아니하고 탈퇴한 경우, 회사는 유료서비스 잔액이
            반환되지 않음으로 인한 일체의 책임을 부담하지 않습니다.
          </li>
          <li>
            회원이 탈퇴 신청을 하는 경우, 서비스를 통하여 회사가 회원에게 부여한
            모든 권리는 탈퇴와 함께 영구히 소멸합니다. 어떠한 경우에도, 회원이
            유상으로 취득하지 아니한 금전적 가치가 있는 재화는 회원의 탈퇴에도
            불구하고 회원에게 현금 기타 금전적 가치가 있는 물품으로 반환되지
            않습니다.
          </li>
        </ol>

        <ItemTitle>제 17조 (서비스의 내용)</ItemTitle>
        <ol>
          <li>
            회사가 사업자 회원에게 제공하는 서비스의 종류는 다음 각 호와 같으며
            구체적 항목은 수시로 변경, 추가될 수 있습니다. 해당 내용은 회사의
            서비스 페이지를 통하여, 또는 제15조 1항에 정한 통지 방법으로
            회원에게 알립니다.
          </li>

          <ol type="A">
            <li>
              회사가 앱을 통하여 사업자 회원에게 제공하는 수입 관리 지원 서비스
            </li>

            <ol type="i">
              <li>수입(매출) 조회 및 상세 매출 정보 조회</li>
              <li>실시간 예상 수입과 주문 내역 조회</li>
              <li>가맹점의 수입, 주문 내역을 활용한 경영정보 분석</li>
            </ol>

            <li>
              회사가 앱을 통하여 가맹점 회원의 업무를 도와줄 수 있는 지원 서비스
            </li>

            <ol type="i">
              <li>가맹점의 POS 이용 가입신청 및 계약 정보 조회 서비스</li>
              <li>가맹점의 POS 정산 조회 및 기타 POS 운영 정보 조회 서비스</li>
            </ol>

            <li>
              회사가 앱을 통하여 모든 회원의 사업장 운영을 도와줄 수 있는 지원
              서비스
            </li>

            <ol type="i">
              <li>부가가치세 신고에 필요한 정보 제공 서비스</li>
              <li>카드사제신고 업무 지원 서비스</li>
              <li>사업장에서 사용하는 소모품 판매 서비스</li>
              <li>
                기타 회원의 사업에 도움이 될 수 있는 정보 제공 서비스 등의 업무
              </li>
            </ol>
          </ol>

          <li>
            회사는 가맹점 회원이 브이디컴퍼니 및 다른 정보보유자의 서비스로부터
            제공받은 데이터를 연동하여, 통합 조회, 관리할 수 있도록 업무를
            지원합니다.
          </li>

          <ol type="A">
            <li>브이디컴퍼니에서 제공하는 거래 내역</li>
            <li>브이디컴퍼니에서 제공하는 정산, 금전 정보</li>
            <li>브이디컴퍼니를 통해 VAN사에서 제공받는 매출 내역</li>
            <li>국세청 홈택스에서 제공하는 각종 경영정보</li>
            <li>
              여신금융협회 가맹점 매출거래정보 통합 시스템에서 제공하는 매출
              내역
            </li>
            <li>
              배달의민족, 요기요, 쿠팡잇츠 등 통신판매중개업자가 제공하는
              거래내역
            </li>
          </ol>

          <li>
            사업자 회원은 회사가 요구하는 기술 요건에 따라 회사가 지정하는
            정보보유자로부터 사업자 회원의 매출 등 상거래 관련 정보에 접근하기
            위해 필요한 정보(이하 “접근 정보”)를 회사에 제공하여야 합니다.
            회사는 이와 같이 사업자 회원으로부터 제공받은 정보를 암호화 등
            방법을 통하여 안전하게 보관합니다.
          </li>
          <li>
            사업자 회원은 회사로 하여금, 전항에 따라 회사에 제공한 접근 정보를
            이용하여, 회사가 정보보유자로부터 사업자 회원에 관한 정보를 수집하는
            것에 동의하며, 이에 필요한 권한을 회사에 부여합니다.
          </li>
          <li>
            사업자 회원은 전항과 같이 회사가 수집한 정보 중, 사업자 회원 개인의
            지위에 따른 개인정보를 제외한 영업관련 기업 정보에 관하여, 이를
            기간과 조건의 제한 없이, 다양한 방법으로 복제, 분석, 가공하는 것을
            허용하며, 본 약관에 따른 서비스 및 회사의 사업 목적에 따른 이용 및
            제3자에 대한 이용 허락 등 처리하도록 허용합니다. 본 항과 관련하여,
            회사가 사업장을 식별할 수 있는 방식으로 정보를 활용하려는 경우에는
            사전에 사업자 회원의 동의를 받습니다.
          </li>
          <li>
            전항에도 불구하고, 회사가 처리하려는 정보에 사업자 회원 개인의
            지위에 따른 개인정보가 포함되는 경우, 회사는 관련법령에 정한 요건에
            따라, 사전에 반드시 사업자 회원으로부터 그 처리와 이용에 대한 동의를
            받아야 합니다.
          </li>
        </ol>

        <ItemTitle>제 18조 (서비스의 한계)</ItemTitle>
        <ol>
          <li>
            {" "}
            회사는 제17조 제1항, 제2항의 각 호에서 조회 · 열람이 가능한 사업자
            회원의 경영정보 등의 데이터를 사업자 회원에게 제공할 뿐 데이터
            연동으로 수집한 경영정보 등 데이터에 대한 정확성, 신뢰도를 보증하지
            않습니다.
          </li>
          <li>
            회사는 POS, 공공기관, 협회 또는 법인 등에서 제공하는 사업자 회원의
            경영정보 등 데이터를 연동하여 사업자 회원이 모든 데이터를 통합하여
            조회, 관리할 수 있도록 업무를 지원하는 것으로 접근 정보가
            부정확하거나, 정보 보유기관의 정책 등이 변경되거나, 정보 보유기관의
            서비스가 중단되는 경우, 전조의 서비스 제공이 어렵거나, 제공되는
            서비스의 내용이 부정확할 수 있습니다.
          </li>
          <li>
            전조의 서비스로 제공되는 정보는 사업자 회원의 경영 관리를 지원하기
            위한 참고 적인 정보로서, 사업자 회원의 경영정보 등 데이터에 대한
            정확성, 신뢰도에 대하여 어떠한 보증이나 책임을 부담하지 않습니다.
          </li>
        </ol>

        <ItemTitle>제 19조 (서비스 내 광고의 게재)</ItemTitle>
        <ol>
          <li>
            회사는 사이트 등에 광고를 게재할 수 있으며, 우편물, 이메일이나 앱
            푸쉬 알림, 모바일 장치, IoT등 신종 기술 등 기기를 이용한 방법으로
            회원에게 광고 등을 전달할 수 있습니다.
          </li>
          <li>
            회원은 서비스 이용 시 사이트 등에 노출되는 광고 게재에 대하여 동의한
            것으로 간주합니다.
          </li>
        </ol>

        <ItemTitle>제 20조 (서비스 이용시간 등)</ItemTitle>
        <span>
          회사는 특별한 사유가 없는 한 연중무휴, 1일 24시간 서비스를 제공합니다.
          다만, 일부 서비스의 경우 그 종류나 성질을 고려하여 별도로 이용시간을
          정할 수 있으며, 회사는 그 이용시간을 회원에게 공지합니다.
        </span>

        <ItemTitle>제 21조(서비스의 중단 또는 변경)</ItemTitle>
        <ol>
          <li>
            다음 각 호의 사유가 발생할 경우, 회사는 일시적으로 서비스를 중지할
            수 있습니다. 사전에 계획된 유지 · 보수 등의 작업인 경우, 회사는
            서비스 중단 시간과 작업 내용을 사전에 공지하되, 우발적 장애 발생 등
            부득이한 사유가 있는 경우에 한하여 그 내용을 사후에 공지할 수
            있습니다.
          </li>

          <ol type="A">
            <li>
              서비스 업데이트나 정보 가공, 자료의 갱신을 위한 시스템 유지·보수
              작업
            </li>
            <li>시스템 장애 해결을 위한 보수작업</li>
            <li>정기 PM(Pre-Maintenance) 작업</li>
            <li>
              기타 시스템 교체 작업이 필요하거나 회선 장애 등 서비스를 중지할
              합리적인 사유가 발생한 경우
            </li>
            <li>
              제17조 제1항, 제2항 각 호의 공공기관, 협회, 법인 등의 데이터
              제공에 장애가 발생하여 원활한 데이터 연동 또는 서비스 제공이
              곤란한 경우
            </li>
          </ol>

          <li>
            회사는 다음 각 호에 해당하는 경우, 그 사유가 해소될 때까지 서비스의
            제공을 중지할 수 있으며, 사전에 예측하거나 사전 공지할 수 있는
            사유가 아닌 경우 그 내용을 사후에 공지합니다.
          </li>

          <ol type="A">
            <li>
              제1항 각 호의 사유가 발생하고 일시적인 서비스 중지로는 그 해결이
              불가능한 경우
            </li>
            <li>기간통신사업자가 전기통신서비스 제공을 중지하는 경우</li>
            <li>
              기타 불가항력적인 사유로 인하여 서비스 제공이 객관적으로 불가능한
              경우
            </li>
          </ol>
        </ol>

        <ItemTitle>제 22조(분쟁의 조정)</ItemTitle>
        <ol>
          <li>
            회사와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기
            위하여 필요한 노력을 하여야 합니다. 본 약관의 해석과 관련하여 이견이
            있거나 양 당사자 사이에 분쟁이 발생한 경우 대한민국 법률, 상관습 및
            신의성실의 원칙에 따라 해결합니다.
          </li>
          <li>
            본 약관과 관련하여 발생한 분쟁이 원만하게 해결되지 아니한 경우 이와
            관련된 소송의 관할법원은 민사소송법에서 정하는 바에 따릅니다.
          </li>
        </ol>

        <ItemTitle>[부칙]</ItemTitle>
        <span>이 약관은 2023년 01월 01일부터 시행됩니다.</span>
      </Contents>
    </Container>
  );
};

export default TermsOfService;
